import { Center } from '@chakra-ui/react'
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'

import Icon from 'src/components/widgets/Icon/Icon'
import { getColorHexValue } from 'src/lib/utils'
import { BrandColor } from 'src/types'

const InsideIcon: React.FC<{
  brandColor: BrandColor
  icon: IconDefinition
}> = ({ brandColor, icon }) => (
  <Center
    boxSize="64px"
    borderRadius="full"
    bg={`${getColorHexValue(brandColor)}1A`}
  >
    <Icon icon={icon} fontSize="21px" color={brandColor} />
  </Center>
)

export default InsideIcon
